export default {
  modifyIndex(state, payload) {
    state.defaultIndex = payload;
  },
  getUserInfoMutation(state, payload) {
    state.userInfo = payload;
  },
};
